import React from 'react'
import NodeZeroMappingForm from './NodeZeroMappingForm';
import NodeZeroCredentialsForm from './NodeZeroCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function NodeZeroConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={NodeZeroMappingForm}
            CredentialsForm={NodeZeroCredentialsForm}
            componentName="Pentest Name"
            componentKey="pentestName"
        />
    )
}